import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

let addToastGlobal = null;
let lastToastMsg = '';
let lastToastTime = 0;

export function showToast(message, type = 'info', duration = 4000) {
  const now = Date.now();
  if (message === lastToastMsg && now - lastToastTime < 2000) return;
  lastToastMsg = message;
  lastToastTime = now;
  if (addToastGlobal) addToastGlobal({ message, type, duration });
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback(({ message, type, duration }) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev.slice(-4), { id, message, type, duration }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
  }, []);

  useEffect(() => { addToastGlobal = addToast; return () => { addToastGlobal = null; }; }, [addToast]);

  const icons = { success: '✅', error: '❌', info: '🔔', warning: '⚠️' };
  const colors = {
    success: 'border-green-500/30 bg-green-500/10',
    error: 'border-red-500/30 bg-red-500/10',
    info: 'border-luna-purple/30 bg-luna-purple/10',
    warning: 'border-yellow-500/30 bg-yellow-500/10',
  };

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 max-w-sm w-full pointer-events-none">
      <AnimatePresence>
        {toasts.map(t => (
          <motion.div key={t.id}
            initial={{ opacity: 0, x: 100, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 100, scale: 0.9 }}
            className={`pointer-events-auto rounded-xl border px-4 py-3 backdrop-blur-xl shadow-lg text-white text-sm ${colors[t.type] || colors.info}`}
          >
            <div className="flex items-center gap-2">
              <span>{icons[t.type] || icons.info}</span>
              <span className="flex-1">{t.message}</span>
              <button onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))}
                className="text-white/40 hover:text-white text-xs ml-2">✕</button>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
